<template>
  <div class="votes-grid-container">
    <Chat />
    <div class="votes-actions">
      <button
        class="button is-medium is-success"
        @click="validate"
        v-if="
          !self.validated &&
            self.vote != '' &&
            !(mrWhite && self.voteMrWhite == '')
        "
      >
        valider
      </button>
    </div>
    <div class="votes-votes">
      <Presentation
        v-for="(player, i) in playerById"
        :key="i"
        :playerId="i"
        :style="`width: calc(100vw / ${nbOfPlayers});`"
      />
    </div>
    <div class="votes-title"><h1>VOTES</h1></div>
  </div>
</template>

<script>
import Presentation from "@/components/Presentation.vue";
import { mapState, mapGetters } from "vuex";
import Chat from "@/components/Chat.vue";

export default {
  name: "Vote",
  data: () => ({
    dialog: undefined
  }),
  components: {
    Presentation,
    Chat
  },
  methods: {
    validate() {
      this.sendMessageToRoom("validate");
    }
  },
  computed: {
    ...mapState("colyseus", ["playerById", "mrWhite"]),
    ...mapGetters("colyseus", ["self"]),
    nbOfPlayers() {
      return Object.keys(this.playerById).length;
    }
  },
  beforeDestroy() {
    if (this.dialog) this.dialog.close();
  },
  mounted() {
    this.$colyseus.room.onMessage("findWord", () => {
      this.dialog = this.$buefy.dialog.prompt({
        message: `Trouvez le mot commun`,
        inputAttrs: {
          placeholder: "..."
        },
        canCancel: false,
        trapFocus: true,
        onConfirm: value => this.sendMessageToRoom("mrWhiteAnswer", value)
      });
      setTimeout(() => {}, 20000);
    }),
      this.$colyseus.room.onMessage("mrWhite", () => {
        this.$buefy.toast.open({
          duration: 5000,
          message: `Mr White doit trouver le mot`,
          position: "is-bottom",
          type: "is-danger"
        });
      });
  }
};
</script>

<style lang="scss" scoped>
.votes-grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.4fr 2.2fr 0.4fr;
  gap: 1px 1px;
  grid-template-areas: ". votes-title votes-title ." "votes-votes votes-votes votes-votes votes-votes" ". votes-actions votes-actions .";
  height: 100vh;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 800px) {
    min-height: 100vh;
  }
}

.votes-actions {
  grid-area: votes-actions;
}

.votes-votes {
  grid-area: votes-votes;
  display: flex;
  justify-content: space-around;
  height: 100%;
  @media only screen and (max-width: 800px) {
    overflow-x: scroll;
    overflow: auto;
    justify-content: start;
  }
}

.votes-title {
  grid-area: votes-title;
}
</style>
